module.exports = __webpack_public_path__ + "img/plex-mono-light.5bbfa5e2.png";